import { render, staticRenderFns } from "./PanelSideNav.vue?vue&type=template&id=fac47ea4&"
import script from "./PanelSideNav.vue?vue&type=script&lang=js&"
export * from "./PanelSideNav.vue?vue&type=script&lang=js&"
import style0 from "./PanelSideNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports